import store from "../store/store";
import { setIsIfoodWidgetInitialized } from "../store/actions/merchantsSlice";

export const removeIFoodWidget = () => {
  if (window.iFoodWidget) {
    // Reinitialize the widget with empty merchantIds to hide it
    window.iFoodWidget.init({
      widgetId: "353dbe5a-caf6-41f9-9628-74518b1d5956",
      merchantIds: [],
    });

    // Remove the iFood script from the document
    const ifoodScript = document.querySelector(
      'script[src="https://widgets.ifood.com.br/widget.js"]'
    );
    if (ifoodScript) {
      ifoodScript.remove();
    }

    // Remove any iFood-related elements from the DOM
    const ifoodElements = document.querySelectorAll('[id^="ifood-"]');
    ifoodElements.forEach((element) => element.remove());

    // Clean up the global iFoodWidget object
    delete window.iFoodWidget;

    store.dispatch(setIsIfoodWidgetInitialized(false));
    console.log("iFood widget has been removed");
  } else {
    console.log("iFood widget is not present");
  }
};
